export default "__VITE_ASSET__AKBDM1O3__"